<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e23uVX/tc-custom/9781504098915.jpg?1724535902033" alt="This image is the cover for the book Three of Us"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Three of Us
      </h1>
      <p class="bookDescription body article font2">
        <b>A short-lived affair causes ripple effects through the years in this novel about the complexities of love and marriage by the author of <i>A Part of Me</i>.</b><br/><br/><i>Molly loves Jack. But so does Carly . . .</i><br/><br/> While working away from home, it’s easy for Jack to have a fling with Carly. Fiancée Molly will never find out; it’s not the first secret he’s kept from her.<br/><br/> When the relationship runs its course, though, Carly can’t move on emotionally. For her, no man compares to Jack. Meanwhile, when Molly is ready to start a family, she’s disappointed to discover that Jack doesn’t share her dream, and she decides to turn her passion for baking into a business venture.<br/><br/> Soon, fate brings the trio together again, impacting each of their lives. Can they finally be honest with each other—and with themselves—before all trust is lost?<br/><br/><b>Praise for Vivien Brown</b><br/><br/> “A truly gripping read.” —<i>My Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vivien Brown
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75e40ef9